import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=720a5eb9&scoped=true"
import script from "./MetadataPanel.vue?vue&type=script&lang=js"
export * from "./MetadataPanel.vue?vue&type=script&lang=js"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=720a5eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a5eb9",
  null
  
)

export default component.exports